import { InjectionToken } from '@angular/core';

export const STORAGE_URL = new InjectionToken<string>('STORAGE_URL');
